import React, { createContext, useContext, useState } from 'react';
import { SNACKBAR_TYPE } from './snacktypes';

const SnackContext = createContext(null);

const useSnackbar = () => {
  const snackbarCtx = useContext(SnackContext);
  if (typeof snackbarCtx === 'undefined') {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return snackbarCtx;
};

function SnackbarProvider({ children }) {
  const [toggleSnack, setToggleSnack] = useState(false);
  const [snackText, setSnackText] = useState('');
  const [snackType, setSnackType] = useState(SNACKBAR_TYPE.DANGER);
  const [snackAction, setSnackAction] = useState('');
  const [timeoutRef, setTimeoutRef] = useState(null);

  const setSnackBar = (textSnack, typeSnack, actionSnack = '') => {
    setSnackText(textSnack);
    setSnackType(typeSnack);
    setSnackAction(actionSnack);
  };

  const safeShowSnack = delay => {
    clearTimeout(timeoutRef);
    if (typeof delay === 'number') {
      setToggleSnack(true);
      setTimeoutRef(
        setTimeout(() => {
          setToggleSnack(false);
        }, delay)
      );
    } else {
      setToggleSnack(false);
    }
  };

  return (
    <SnackContext.Provider
      value={{
        toggleSnack,
        setToggleSnack: safeShowSnack,
        snackText,
        setSnackText,
        snackType,
        setSnackType,
        setSnackBar,
        snackAction,
        setSnackAction
      }}
    >
      {children}
    </SnackContext.Provider>
  );
}

export { useSnackbar, SnackbarProvider };
